<template>
  <div class="d-flex flex-row">

    <div class="mr-1" v-for="(network, i) in network_list" :key="i">
      <ShareNetwork
        :network="network"
        :url="url ? url : ''"
        :title="title ? title : ''"
        :description="description ? description : ''"
        quote="The hot reload is so fast it\'s near instant. - Evan You"
        hashtags="stonebox"
      >
       <i class="icon" :class="'icon-' + network"></i>
      </ShareNetwork>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareList",
  props: {
    network_list: Array,
    url: String,
    title: String,
    description: String,
  },
};
</script>
<style lang="scss" scoped>
.icon{
    height: 28px;
    width:  28px;
}
</style>